var exports = {
  "kJ": "GiftEmbed.module__iconCircle___VG8yeV",
  "SP": "GiftEmbed.module__iconCircleActive___VG8yeV",
  "PP": "GiftEmbed.module__iconCircleInactive___VG8yeV",
  "_O": "GiftEmbed.module__iconCircleDisabled___VG8yeV",
  "Kk": "GiftEmbed.module__icon___VG8yeV",
  "m5": "GiftEmbed.module__iconError___VG8yeV",
  "DD": "GiftEmbed.module__title___VG8yeV",
  "jn": "GiftEmbed.module__titlePrimary___VG8yeV",
  "xP": "GiftEmbed.module__titleTertiary___VG8yeV",
  "S3": "GiftEmbed.module__titleDanger___VG8yeV",
  "xF": "GiftEmbed.module__subRow___VG8yeV",
  "Cz": "GiftEmbed.module__helpRow___VG8yeV",
  "U6": "GiftEmbed.module__pulse___VG8yeV",
  "mj": "GiftEmbed.module__skeletonCircle___VG8yeV",
  "Iz": "GiftEmbed.module__skeletonTitle___VG8yeV",
  "hI": "GiftEmbed.module__skeletonHelp___VG8yeV",
  "G3": "GiftEmbed.module__skeletonButton___VG8yeV",
};

module.exports = exports;
